
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 13c2.67 0 8 1.34 8 4v3H1v-3c0-2.66 5.33-4 8-4zm0-9a4 4 0 110 8 4 4 0 010-8zm0 10.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1zm0-9a2.1 2.1 0 100 4.2 2.1 2.1 0 000-4.2z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.183 3.66l-4.808 4.978-2.536-2.455 1.322-1.365 1.17 1.132 3.486-3.61 1.366 1.32zM22.183 8.66l-4.808 4.978-2.536-2.456 1.322-1.364 1.17 1.132 3.486-3.61 1.366 1.32z","fill":"currentColor"}})])
          )
        }
      }
    